"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importStar(require("styled-components"));
var Button = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-block;\n    \n    svg{\n        vertical-align: middle;\n        width: 20px;\n        height: 20px;\n        padding-right: 5px;\n    }\n    ", "\n"], ["\n    display: inline-block;\n    \n    svg{\n        vertical-align: middle;\n        width: 20px;\n        height: 20px;\n        padding-right: 5px;\n    }\n    ", "\n"])), function (props) { return props.theme.changeButton; });
var Text = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: inline-block;\n    vertical-align: middle;\n"], ["\n    display: inline-block;\n    vertical-align: middle;\n"])));
var ChangeButton = /** @class */ (function (_super) {
    __extends(ChangeButton, _super);
    function ChangeButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChangeButton.prototype.render = function () {
        return (react_1.default.createElement(Button, { onClick: this.props.onClick, "aria-label": this.props.text, className: this.props.className, "data-automationid": this.props.automationId },
            this.props.theme.svgs.icon_change_model,
            react_1.default.createElement(Text, null, this.props.text)));
    };
    ChangeButton.propTypes = {
        /** function to call on click */
        onClick: prop_types_1.default.func.isRequired,
        /** Text to display to the right of the icon */
        text: prop_types_1.default.string.isRequired,
        /** Id to refernce button in functional testing */
        automationId: prop_types_1.default.string.isRequired,
        theme: prop_types_1.default.any,
        className: prop_types_1.default.string,
    };
    ChangeButton.defaultProps = {
        onClick: function () { },
        text: 'test',
        automationId: 'changemodel',
    };
    return ChangeButton;
}(react_1.Component));
exports.default = styled_components_1.withTheme(ChangeButton);
var templateObject_1, templateObject_2;
//# sourceMappingURL=ChangeButton.js.map